<script>
import { mapState, mapActions } from 'vuex'
import { execute } from '@/api/acessorelatorio'

export default {
  data: () => ({
    form: {},
    fields: []
  }),
  mounted () {
    this.trataFields()
  },
  watch: {
    'relatorio.estado': function () {
      this.trataFields()
    }
  },
  computed: {
    ...mapState({
      relatorio: state => state.relatorio.relatorio,
      modalreport: state => state.relatorio.report
    })
  },
  methods: {
    ...mapActions({
      report: 'relatorio/report',
      close: 'relatorio/close',
      closeReport: 'relatorio/closeReport'
    }),
    percorreFields (param) {
      // É um Array | Objeto
      if (typeof param === 'object') {
        for (let x in param) param[x] = this.percorreFields(param[x])
        return param
      // É um Campo Eval
      } else if (typeof param === 'string' && param.includes('{{')) {
        let evalFunction = param.replace('{{', '').replace('}}', '')
        /* eslint no-eval: 0 */
        return eval(evalFunction)
      } else return param
    },
    limpaForm () {
      this.form = {}
    },
    trataFields () {
      this.limpaForm()
      try {
        if (this.relatorio.schema && this.relatorio.schema.filtros) {
          let json = JSON.parse(this.relatorio.schema.filtros)
          this.fields = this.percorreFields(json)
        } else this.filtrar()
      } catch (e) {
        this.filtrar()
      }
    },
    async filtrar () {
      if (this.relatorio.schema && this.relatorio.schema.urlDados) {
        let dados = await execute(this.relatorio.schema.urlDados, this.form)
        let report = JSON.parse(this.relatorio.schema.report)
        this.close()
        return this.report({ report, dados })
      }
    }
  }
}
</script>

<template>
  <div>
    <v-dialog v-model="relatorio.estado" @input="v => v || closeReport()" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Filtros
        </v-card-title>
        <v-card-text class="relatorio">
          <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="filtrar" />
          <div class="footer">
            <v-btn @click="filtrar" color="primary"> Filtrar </v-btn>
            <v-btn @click="close"> Cancelar </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalreport.estado" @input="v => v || closeReport()" width="1024">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Relatório
        </v-card-title>
        <v-card-text class="conteudo">
          <div class="body">
            <ui-st-report :report="modalreport.report" :dados="modalreport.dados" />
          </div>
          <div class="button-footer">
            <v-btn @click="closeReport"> Fechar </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
  .relatorio {
    text-align: left;
  }
  .relatorio .footer {
    margin-left: -7px;
    padding: 0;
  }
  .conteudo {
    text-align: left;
  }
  .conteudo .button-footer {
    text-align: right;
  }
  .conteudo .body {
    width: 100%;
    height: 350px;
    overflow: auto;
  }
</style>
